import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { VeltProvider } from '@veltdev/react';

const rootContainer = document.getElementById('root');
const root = createRoot(rootContainer as HTMLElement);
root.render(
  // @ts-ignore
  <VeltProvider apiKey={process.env.REACT_APP_SNIPPYLY_API_KEY || ''} config={{version: 'latest'}}>
    <App />
  </VeltProvider>
);